import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { LaboService } from '../../../../services/labo-service/labo.service';
import { LaboDTO } from '../../../_models/LaboDTO';
import { DecimalPipe } from '@angular/common';
import { MatIcon } from "@angular/material/icon"; // 👈 ajoute ça
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-client-labo-list',
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, ClientsService],
    imports: [
    DecimalPipe, MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
    MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox,
    MatIcon
],
    templateUrl: './labo-list.component.html',
    styleUrl: './labo-list.component.scss'
})
export class LaboListComponent implements OnInit, AfterViewInit {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<LaboDTO>();
    searchValue: string = ''
    labo?: LaboDTO
    loadingTable: boolean = true;

    displayedColumns: string[] = ['raisonSociale', 'ice', 'type', 'capital', 'adresseMail', 'telephone', 'fax', 'siteWeb','tva','registreCommerce','patente','cnss','i_f','logo1','adresse','dureeEnJours'];
    columns: string[] = [...this.displayedColumns];
columnLabels: Record<string, string> = {
  raisonSociale: 'Raison sociale',
  ice: 'ICE',
  type: 'Type',
  capital: 'Capital',
  adresseMail: 'Email',
  telephone: 'Téléphone',
  fax: 'Fax',
  siteWeb: 'Site web',
  tva: 'TVA',
  registreCommerce: 'Registre de commerce',
  patente: 'Patente',
  cnss: 'CNSS',
  i_f: 'IF',
  logo1: 'Logo',
  adresse: 'Adresse',
  dureeEnJours: 'Délai (jours)',
};
    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private laboService: LaboService,
        private clientService: ClientsService,
        private dialogService: DialogService,

        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchLaboList()
        this.initializeEditForm();
        this.fetchClientList();
        this.initializeCreateForm()
        this.getColsCookie()
    }

    fetchLaboList() {
        this.laboService.findAll().subscribe({
            next: response => { 
                console.log('✅ Données reçues du backend:', response);

                if (response.status) {
                    console.log('✅ Données reçues du backend:', response);
                    this.dataSource.data = response.data;
                    this.loadingTable = false;
                }
            },
            error: err => console.error("❌ Erreur lors de la récupération de labo :", err) // Ajout pour voir les erreurs éventuelles
        });
    }
    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            raisonSociale: ['', Validators.required],
            ice: ['', Validators.required],
            type: ['', Validators.required],
            capital: ['', Validators.required],
            tva: ['', Validators.required],
            adresseMail: ['', Validators.required],
            telephone: ['', Validators.required],
            siteWeb: ['', [Validators.required]],
            registreCommerce: ['', [Validators.required]],
            patente: ['', Validators.required],
            cnss: [null, Validators.required],
            i_f: [null, Validators.required],
            logo1: [null, Validators.required],
            adresse: [null, Validators.required],
            fax:[''],
            dureeEnJours: ['', Validators.required],

        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            raisonSociale: ['', Validators.required],
            ice: ['', Validators.required],
            type: ['', Validators.required],
            capital: ['', Validators.required],
            tva: ['', Validators.required],
            adresseMail: ['', Validators.required],
            telephone: ['', Validators.required],
            siteWeb: ['', [Validators.required]],
            registreCommerce: ['', [Validators.required]],
            patente: ['', Validators.required],
            cnss: [null, Validators.required],
            i_f: [null, Validators.required],
            logo1: [null, Validators.required],
            adresse: [null, Validators.required],
            fax:[''],
            dureeEnJours: ['', Validators.required],
        });
    }
    public phoneValidator(control: AbstractControl): ValidationErrors | null {
        const validPhonePattern = /^[+\d][\d\s-]*$/;
        return validPhonePattern.test(control.value) ? null : { invalidPhone: true };
    }

    selectedLogoName = '';
logoPreview: string | ArrayBuffer | null = null;
selectedLogoFile!: File;

onLogoSelected(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file = input.files[0];
  this.selectedLogoFile = file;
  this.selectedLogoName = file.name;

  // Update form control
  this.form.patchValue({ logo1: file });
  this.form.get('logo1')?.updateValueAndValidity();

  // Preview
  const reader = new FileReader();
  reader.onload = () => {
    this.logoPreview = reader.result;
  };
  reader.readAsDataURL(file);
}


    getClientName(clientId: number): string {
        const client = this.clientList.find(client => client.id === clientId);
        return client?.socialReason ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }
      
      
    openEditModal(element: LaboDTO) {
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    private fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: response => {
                if(response.status){
                    this.clientList = response.data
                }
            }
        })
    }
saveLabo(): void {
  console.log('📤 [saveLabo] Tentative de sauvegarde du labo');

  if (this.form.invalid) {
    console.warn('⚠️ Formulaire invalide', this.form.value);
    this.form.markAllAsTouched();
    this.dialogService.openInvalidFormDialog();
    return;
  }

  // 🔹 Création FormData
  const formData = new FormData();

  // 🔹 Parcourir les champs du formulaire
  Object.keys(this.form.controls).forEach(key => {
    const value = this.form.get(key)?.value;

    if (value !== null && value !== undefined) {
      formData.append(key, value);
      console.log(`➡️ Champ ajouté : ${key} =`, value);
    }
  });

  // 🔹 Vérification spéciale logo
  const logoFile = this.form.get('logo1')?.value;

  if (logoFile instanceof File) {
    console.log('🖼️ Logo détecté :', {
      name: logoFile.name,
      size: logoFile.size,
      type: logoFile.type
    });
  } else {
    console.warn('⚠️ Aucun fichier logo détecté', logoFile);
  }

  console.log('📦 FormData final :');
  formData.forEach((value, key) => {
    console.log(`   - ${key}:`, value);
  });

  // 🔹 Appel API
  this.laboService.createLabo(formData).subscribe({
    next: response => {
      console.log('✅ Réponse API :', response);

      // 🚀 Ici on ignore totalement response.status
      console.log('🎉 Labo créé avec succès');
      this.form.reset();
      this.fetchLaboList();
      this.modalService.dismissAll();
      this.dialogService.openSuccessDialog(
        'Laboratoire créé avec succès'
      );
    },
    error: err => {
      console.error('❌ Erreur API complète :', err);
      console.error('❌ Body erreur :', err?.error);
      this.dialogService.openDangerDialog('Erreur serveur');
    }
  });
}


onLogoSelected1(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    const file = input.files[0];

    // Mettre le fichier dans le form
    this.editForm.patchValue({ logo1: file });
    this.editForm.get('logo1')?.updateValueAndValidity();

    // Nom du fichier pour l'affichage
    this.selectedLogoName = file.name;

    // Aperçu
    const reader = new FileReader();
    reader.onload = () => {
      this.logoPreview = reader.result;
    };
    reader.readAsDataURL(file);
  }
}

getSafeImageUrl(logo: string): string {
  console.log('🔵 getSafeImageUrl | logo reçu =', logo);

  if (!logo) {
    console.warn('⚠️ logo vide → logo par défaut');
    return 'https://i.postimg.cc/WhMWJmx1/logo-laboralim.png';
  }

  if (logo.startsWith('http') || logo.startsWith('data:image')) {
    console.log('✅ URL absolue → retour direct =', logo);
    return logo;
  }

  const url = `${environment.base_url.replace(/\/$/, '')}/${logo.replace(/^\//, '')}`;

  console.log('🔗 URL construite =', url);
  console.log('   base_url =', environment.base_url);
  console.log('   logo =', logo);

  return url;
}

updatePoc(): void {
  console.log('📤 [updatePoc] Tentative de mise à jour du labo');

  if (this.editForm.invalid) {
    console.warn('⚠️ Formulaire update invalide', this.editForm.value);
    this.editForm.markAllAsTouched();
    this.dialogService.openInvalidFormDialog();
    return;
  }

  const laboId = this.editForm.get('id')?.value;
  const formData = new FormData();

  Object.keys(this.editForm.controls).forEach(key => {
    const value = this.editForm.get(key)?.value;
    if (value !== null && value !== undefined) {
      if (value instanceof File) {
        formData.append(key, value, value.name);
      } else {
        formData.append(key, value);
      }
      console.log(`➡️ Champ ajouté : ${key} =`, value);
    }
  });

  // Convertir dureeEnJours en string
  if (formData.has('dureeEnJours')) {
    formData.set('dureeEnJours', Number(this.editForm.get('dureeEnJours')?.value).toString());
  }

  console.log('📦 FormData final pour update:');
  formData.forEach((value, key) => console.log(`   - ${key}:`, value));

  // 🔹 Appel API
  this.laboService.update(laboId, formData).subscribe({
    next: response => {
      console.log('✅ Réponse API update:', response);

      // 🔹 Utiliser response.data qui contient le labo mis à jour
      this.updateTableRow(response.data);
      this.modalService.dismissAll();
      this.dialogService.openSuccessDialog('Laboratoire modifié avec succès');
    },
    error: err => {
      console.error('❌ Erreur API update:', err);
      this.dialogService.openDangerDialog('Erreur serveur');
    },
    complete: () => this.initializePaginatorAndSort()
  });
}


    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer ce laboratoire?')
            .then((result: any) => {
                if (result) {
                    this.deleteClient(element.id);
                }
            });
    }
    deleteClient(id: number) {
        this.laboService.delete(id).subscribe({
            next: response => {
                if (response) {
                    this.removeTableRow(id);
                    this.dialogService.openSuccessDialog('Laboratoire supprimé avec succès')
                }
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

openViewModel(element: LaboDTO) {
  console.log('📤 [openViewModel] Tentative d’ouverture du modal pour le labo', element);

  this.labo = element;
  console.log('📝 Labo actuel assigné à this.labo:', this.labo);

  // Génération du logoFullUrl si nécessaire
  if (!this.labo.logoFullUrl && this.labo.logo1) {
    this.labo.logoFullUrl = `${environment.base_url}/${this.labo.logo1}`;
  }
  console.log('✅ LogoFullUrl généré à partir de logo1 :', this.labo.logoFullUrl);
  console.log('📦 this.labo final avant ouverture du modal :', this.labo);

  // 🔹 Ouverture du modal
  this.modalService.open(this.viewModal, {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg'
  });
}




    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`labo_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const sampleCols = this.cookieService.get(`labo${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }
}

